/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![NearbyScanIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABxUlEQVR4nOWUMS8EQRTHrxIJoqGjFhQSChKFSkJu5723l8y+d0g0vsQdER+Aklon5BKtKEVHodFw3ak4womTECGzt3fWuZ3sUolJJpvMznu/9//Pm0ml/s1A5H4gLiiSiplAvA+gBxIlUSg7CrmsMt5kc3KFcgsk718n35l/CQD85gcib4fXgbjwPXkwUfaSKKiaIEVy/mWdjCURAOKHJApK9UAiHowDUCj3sQGAchyqbLOxbg400iLeTaBANkLBr2nXG/EBoAfMgX6vnsuuO98XXwEINMkvzmjd22hTlD3juT+RdxMlN0Nr3QbEN00WXADooUSJrCqI11tY8QIoW+Z+aK27fwVwnGxPzYaotpS6fVVj6Q9VyEoMQFFr3envB3EB5QyQn83XwSxZASYQUK5tAMTsUqvGaBRAnLFCFEnOBqh3kCI+DW5/bnp6oUMh5wPAiR2gZNgGMB0Xfl4+7YKuYM+TFTC1uNgeRwGQXAadlvetJV6ut7cVEAS/R07Xk5oCXot4BFd/B0A+NHtqVctV070pmfNI9LpCSxWSNvuI5sYUymNw2BXH9UZTcYZDPGuDKOKDRjGuN6FIjgBkPFbyPzM+AOHrumHYZflRAAAAAElFTkSuQmCC)
 */
export const NearbyScanIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M13 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M3 5v-.75C3 3.56 3.56 3 4.25 3s1.24.56 1.33 1.25C6.12 8.65 9.46 12 13 12h1c.35 0 .7.02 1.04.07.4.05.53.56.26.87a5.45 5.45 0 0 0-1.3 3.54 7.63 7.63 0 0 0 1.72 4.64c.26.35.03.88-.4.88H9a2 2 0 0 1-2-2v-2.22c0-1.57-.67-3.05-1.53-4.37A15.85 15.85 0 0 1 3 5Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M19.87 21.73c.9-.7 3.13-2.7 3.13-5.25a3.5 3.5 0 0 0-7 0c0 2.56 2.24 4.55 3.13 5.25.22.17.52.17.74 0ZM19.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
